import { trackPerformanceBreakdown } from "./__internal__/trackPerformanceBreakdown";

export const trackMainJsExecuted = () => {
  trackPerformanceBreakdown({ name: "mainJsExecuted" });
};
